<script setup lang="ts">
import SecondaryButton from '@/packages/ui/src/Buttons/SecondaryButton.vue';
import { PlusIcon } from '@heroicons/vue/16/solid';
import { useQuery } from '@tanstack/vue-query';
import InvoiceTableRow from './InvoiceTableRow.vue';
import InvoiceTableHeading from './InvoiceTableHeading.vue';
import { router } from '@inertiajs/vue3';
import { api } from '@/packages/api/src';
import { computed } from 'vue';
import { getCurrentOrganizationId } from '@/utils/useUser';

const organizationId = computed(() => getCurrentOrganizationId());

const { data: invoices } = useQuery({
    queryKey: ['invoices'],
    queryFn: async () => {
        const organizationId = getCurrentOrganizationId();
        if (organizationId === null) {
            throw new Error('No current organization id - fetch invoices');
        }
        const response = await api.getInvoices({
            params: {
                organization: organizationId,
            },
        });
        return response.data;
    },
    enabled: computed(() => !!organizationId.value),
});

function createInvoice() {
    router.visit('/invoices/create');
}
</script>

<template>
    <div class="flow-root">
        <div class="inline-block min-w-full align-middle">
            <div
                data-testid="invoice_table"
                class="grid min-w-full"
                style="grid-template-columns: minmax(150px, auto) 1fr 150px 150px 150px 80px 80px">
                <InvoiceTableHeading></InvoiceTableHeading>
                <div v-if="!invoices?.length" class="col-span-7 py-24 text-center">
                    <h3 class="text-text-primary font-semibold">No invoices found</h3>
                    <p class="pb-5">Create your first invoice now!</p>
                    <SecondaryButton :icon="PlusIcon" @click="createInvoice"
                        >Create your First Invoice</SecondaryButton
                    >
                </div>
                <template v-for="invoice in invoices" :key="invoice.id">
                    <InvoiceTableRow :invoice="invoice"></InvoiceTableRow>
                </template>
            </div>
        </div>
    </div>
</template>
